import React, {useCallback} from "react";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {MODE_CREATE, MODE_EDIT} from "../../../../codes";
import Editor from "../../../../common/Editor";
import useTagEditor from "./useTagEditor";
import {FormControlTags} from "../../../../common/FormControlTags";
import ColorBox from "../../../../common/ColorBox";
import {DeleteModal} from "../../../../common/AppModal";
import useProject from "../../../../util/useProject";

export const TagEditor = () => {
  const {
    show,
    t,
    mode,
    hideTagEditor,
    editedTag,
    updateEditedTag,
    submit,
    deleteConfirmationModal,
    showDeleteConfirmationModal,
    hideDeleteConfirmationModal,
    onDeleteTag
  } = useTagEditor();

  const {runWithExpiration} = useProject();

  return <Editor
    show={show}
    title={t(mode === MODE_CREATE ? "tag_editor_title_add" : "tag_editor_title_edit")}
    onShow={useCallback(() => document.getElementById("tag-editor-name").focus(), [])}
    onSubmit={runWithExpiration(submit)}
    onCancel={hideTagEditor}
    onDelete={mode === MODE_EDIT ? runWithExpiration(showDeleteConfirmationModal) : null}
    submitLabel={t("tag_editor_button_save")}
    cancelLabel={t("tag_editor_button_cancel")}
  >
    <Form.Group as={Row} className="mb-2" controlId="tag-editor-name">
      <Form.Label column sm={4}>{t("tag_editor_field_name")}</Form.Label>
      <Col sm={8}>
        <FormControlTags type="text" value={editedTag.name} onChange={updateEditedTag("name")}
                         isInvalid={editedTag.errors.name} multiple={false}/>
        <Form.Control.Feedback type="invalid">{t(editedTag.errors.name)}</Form.Control.Feedback>
      </Col>
    </Form.Group>

    <Form.Group as={Row} className="mb-2" controlId="tag-editor-description">
      <Form.Label column sm={4}>{t("tag_editor_field_description")}</Form.Label>
      <Col sm={8}>
        <Form.Control type="text" value={editedTag.description} onChange={updateEditedTag("description")}/>
      </Col>
    </Form.Group>

    <Form.Group as={Row} className="mb-2" controlId="tag-editor-color">
      <Form.Label column sm={4}>{t("tag_editor_field_color")}</Form.Label>
      <Col sm={8}>
        <ColorBox value={editedTag.color} onChange={updateEditedTag("color")}/>
      </Col>
    </Form.Group>

    <DeleteModal
      show={deleteConfirmationModal}
      title={t("modal_delete_title")}
      cancelLabel={t("modal_delete_button_cancel")}
      submitLabel={t("modal_delete_button_apply")}
      onCancel={hideDeleteConfirmationModal}
      onSubmit={onDeleteTag}
    >
      {t("modal_delete_body")}
    </DeleteModal>
  </Editor>;
};
